import React from 'react';
import './ComingSoonPage.css';

const ComingSoonPage = () => {
    return (
        <div className="coming-soon-container">
            <div className="logo-container">
                <img src="/logotrans.png" alt="S R Patel Jewels Art logo" className="logo" />
            </div>
            <h1 className="coming-soon-title">Our Website is Launching Soon!</h1>
            <p className="coming-soon-text">Stay tuned for an exquisite collection of silver ornaments.</p>
        </div>
    );
};

export default ComingSoonPage;